import React from 'react';
import './ActiveTradesHeader.css';
import { PanelHeaderProps } from 'components/TradeTabPanel/TradePanelSection';

// The black block on /sending: title plus the per-tab panel as its child
export default function ActiveTradesHeader({ collapseControl, children }: PanelHeaderProps) {
  return (
    <div className="active-trades-header-container ttp-block">
      {/* ttp-block-head floats over the map, which runs under it */}
      <div className="active-trades-header ttp-block-head">
        <h2 className="active-trades-title">Active Trades</h2>
        {collapseControl}
      </div>
      {children}
    </div>
  );
}
